import type { ComponentType } from 'react';

import * as Comp from '@vb-django/components/editor/PuckComps';

import type { RawPuckComponent } from '@helpers/Puckhelper';

type PuckCompMap = Record<string, ComponentType<Record<string, unknown>>>;

type PuckPostRendererProps = {
  components: RawPuckComponent[];
};

export const PuckPostRenderer = ({ components }: PuckPostRendererProps) => {
  return (
    <>
      {components.map((component, index) => {
        const Component = (Comp as PuckCompMap)[component.type];
        if (!Component) {
          console.warn('[PuckPostRenderer] Unknown component:', component.type);
          return null;
        }
        return <Component key={index} {...(component.props ?? {})} />;
      })}
    </>
  );
};
